import request from '@ps/utils/request'
import { AxiosPromise } from 'axios'

export function downloadZip(data: {
  filename: string
  files: string
}): AxiosPromise {
  return request({
    url: '/ps/common/download-zip',
    method: 'post',
    data,
  })
}

export function assetUpdate(data: {
  id: number
  img_file: string
  img_base64?: string
  files?: string
  from?: number
}): AxiosPromise {
  return request({
    url: '/ps/common/asset/update',
    method: 'post',
    data,
  })
}

export function assetCreate(data: {
  res_type: number
  name: string
  access_allow_pt: number
  files: string
  img_base64: string
}): AxiosPromise {
  return request({
    url: '/ps/common/asset/create',
    method: 'post',
    data,
  })
}
